<template>
    <div class="w-full relative">
        <ModelImage
            :src="
                coverPictureId
                    ? route('media.show', {
                          media: coverPictureId,
                          conversion: 'full',
                      })
                    : null
            "
            :modelClass="modelClass"
            :useAccentBg="true"
            :hideIcon="true"
            heightClasses="h-72"
            imageClasses="h-72 rounded-img w-full"
            objectFitClasses="object-cover object-center"
        />
        <ModelImage
            :src="
                detailPictureId
                    ? route('media.show', {
                          media: detailPictureId,
                          conversion: 'full',
                      })
                    : null
            "
            :modelClass="modelClass"
            :fallbackBorder="`border border-${modelClass}-accent`"
            :class="[
                `ml-5 -mt-40 border border-${modelClass}`,
                { 'rounded-full': modelClass == 'user' },
                { 'rounded-img': modelClass == 'organization' },
            ]"
            heightClasses="h-36 aspect-square"
            classes="flex items-center bg-white"
            :imageClasses="[{ 'size-36': modelClass == 'user' }]"
            objectFitClasses="object-center object-cover"
        />
    </div>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
export default {
    name: 'CoverPicture',

    components: {
        ModelImage,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        detailPictureId: {
            type: [Number, null],
            default: null,
        },
        coverPictureId: {
            type: [Number, null],
            default: null,
        },
    },
}
</script>
